import { useState } from 'react';

interface TaxInvoiceModalProps {
  isOpen: boolean;
  onClose: () => void;
  order: any;
}

export default function TaxInvoiceModal({ isOpen, onClose, order }: TaxInvoiceModalProps) {
  if (!isOpen) return null;

  const amount = parseInt(order?.amount?.replace(/[^0-9]/g, '') || '0');
  const supplyPrice = Math.round(amount / 1.1);
  const vat = amount - supplyPrice;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl shadow-2xl max-w-4xl w-full max-h-[90vh] overflow-y-auto">
        <div className="sticky top-0 bg-white border-b border-gray-200 px-6 py-4 flex items-center justify-between">
          <h2 className="text-xl font-bold text-gray-900">세금계산서</h2>
          <button 
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 w-8 h-8 flex items-center justify-center cursor-pointer"
          >
            <i className="ri-close-line text-2xl"></i>
          </button>
        </div>

        <div className="p-6 space-y-6">
          <div className="text-center mb-6">
            <h3 className="text-2xl font-bold text-gray-900 mb-2">세금계산서</h3>
            <p className="text-gray-600">계산서 번호: {order?.taxInvoiceNumber || 'TAX-2024-001'}</p>
          </div>

          <div className="grid grid-cols-2 gap-6">
            <div className="border border-gray-300 rounded-lg p-4">
              <h4 className="font-semibold text-gray-900 mb-3 border-b pb-2">공급자</h4>
              <div className="text-sm text-gray-700 space-y-2">
                <div className="flex justify-between">
                  <span className="text-gray-600">사업자등록번호:</span>
                  <span className="font-medium">123-45-67890</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-600">상호:</span>
                  <span className="font-medium">{order?.vendor}</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-600">대표자:</span>
                  <span className="font-medium">{order?.manager}</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-600">업태:</span>
                  <span className="font-medium">서비스업</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-600">종목:</span>
                  <span className="font-medium">웨딩서비스</span>
                </div>
              </div>
            </div>

            <div className="border border-gray-300 rounded-lg p-4">
              <h4 className="font-semibold text-gray-900 mb-3 border-b pb-2">공급받는자</h4>
              <div className="text-sm text-gray-700 space-y-2">
                <div className="flex justify-between">
                  <span className="text-gray-600">사업자등록번호:</span>
                  <span className="font-medium">987-65-43210</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-600">상호:</span>
                  <span className="font-medium">체리쉬웨딩</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-600">대표자:</span>
                  <span className="font-medium">김대표</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-600">업태:</span>
                  <span className="font-medium">서비스업</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-600">종목:</span>
                  <span className="font-medium">웨딩플래닝</span>
                </div>
              </div>
            </div>
          </div>

          <div>
            <h4 className="font-semibold text-gray-900 mb-3">공급 내역</h4>
            <table className="w-full border-collapse border border-gray-300">
              <thead className="bg-gray-100">
                <tr>
                  <th className="border border-gray-300 px-4 py-2 text-left text-sm">품목</th>
                  <th className="border border-gray-300 px-4 py-2 text-right text-sm">수량</th>
                  <th className="border border-gray-300 px-4 py-2 text-right text-sm">공급가액</th>
                  <th className="border border-gray-300 px-4 py-2 text-right text-sm">세액</th>
                  <th className="border border-gray-300 px-4 py-2 text-right text-sm">합계</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="border border-gray-300 px-4 py-2 text-sm">{order?.service}</td>
                  <td className="border border-gray-300 px-4 py-2 text-right text-sm">1</td>
                  <td className="border border-gray-300 px-4 py-2 text-right text-sm">{supplyPrice.toLocaleString()}원</td>
                  <td className="border border-gray-300 px-4 py-2 text-right text-sm">{vat.toLocaleString()}원</td>
                  <td className="border border-gray-300 px-4 py-2 text-right text-sm font-medium">{amount.toLocaleString()}원</td>
                </tr>
              </tbody>
              <tfoot className="bg-gray-50">
                <tr>
                  <td colSpan={2} className="border border-gray-300 px-4 py-2 text-sm font-semibold">합계</td>
                  <td className="border border-gray-300 px-4 py-2 text-right text-sm font-semibold">{supplyPrice.toLocaleString()}원</td>
                  <td className="border border-gray-300 px-4 py-2 text-right text-sm font-semibold">{vat.toLocaleString()}원</td>
                  <td className="border border-gray-300 px-4 py-2 text-right text-sm font-semibold">{amount.toLocaleString()}원</td>
                </tr>
              </tfoot>
            </table>
          </div>

          <div className="bg-purple-50 rounded-lg p-4">
            <div className="grid grid-cols-3 gap-4 text-center">
              <div>
                <div className="text-sm text-gray-600 mb-1">공급가액</div>
                <div className="text-xl font-bold text-gray-900">{supplyPrice.toLocaleString()}원</div>
              </div>
              <div>
                <div className="text-sm text-gray-600 mb-1">세액 (10%)</div>
                <div className="text-xl font-bold text-purple-600">{vat.toLocaleString()}원</div>
              </div>
              <div>
                <div className="text-sm text-gray-600 mb-1">합계</div>
                <div className="text-xl font-bold text-blue-600">{amount.toLocaleString()}원</div>
              </div>
            </div>
          </div>

          <div className="text-sm text-gray-600 text-center">
            <p>이 세금계산서는 전자세금계산서로 발행되었습니다.</p>
            <p className="mt-1">발행일: {new Date().toLocaleDateString('ko-KR')}</p>
          </div>
        </div>

        <div className="sticky bottom-0 bg-gray-50 border-t border-gray-200 px-6 py-4 flex items-center justify-end gap-3">
          <button 
            onClick={onClose}
            className="px-6 py-2 text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors font-medium whitespace-nowrap cursor-pointer"
          >
            닫기
          </button>
          <button 
            className="px-6 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 transition-colors font-medium whitespace-nowrap cursor-pointer"
          >
            <i className="ri-download-line mr-2"></i>
            다운로드
          </button>
        </div>
      </div>
    </div>
  );
}
